import { useEffect } from 'react';
import { useAppStore } from '../state/appStore';
import { useProgressStore } from '../state/progressStore';
import { MainMenu } from './screens/MainMenu';
import { LevelSelect } from './screens/LevelSelect';
import { LevelIntro } from './screens/LevelIntro';
import { TheoryScreen } from './screens/TheoryScreen';
import { SettingsScreen } from './screens/SettingsScreen';
import { ControlsScreen } from './screens/ControlsScreen';
import { Debrief } from './screens/Debrief';
import { GameScreen } from './game/GameScreen';
import { validateLevels } from '../levels';
import { hasKey } from '../i18n';

export function App() {
  const screen = useAppStore((s) => s.screen);
  const activeLevelId = useAppStore((s) => s.activeLevelId);
  const gameNonce = useAppStore((s) => s.gameNonce);
  const { loaded, hydrate } = useProgressStore();

  useEffect(() => {
    void hydrate();
    if (import.meta.env.DEV) {
      const problems = validateLevels(hasKey);
      if (problems.length) console.warn('Problemas en niveles:', problems);
    }
  }, [hydrate]);

  if (!loaded) return <div className="h-full w-full bg-slate-950" />;

  switch (screen) {
    case 'menu':
      return <MainMenu />;
    case 'levels':
      return <LevelSelect />;
    case 'theory':
      return <TheoryScreen />;
    case 'settings':
      return <SettingsScreen />;
    case 'controls':
      return <ControlsScreen />;
    case 'intro':
      return <LevelIntro />;
    case 'game':
      return <GameScreen key={`${activeLevelId}:${gameNonce}`} />;
    case 'debrief':
      return <Debrief />;
  }
}
